<!-- <div *ngIf="loading$ | async" class="spinner-container"> -->
<div class="container" data-test="indicador-carregamento">
    <span class="message" *ngIf="message != ''" [ngClass]="{ 'green-text': succeeded == true, 'red-text': failed == true }">{{message}}</span>
    <div class="spinner-container">
        <span class="custom-spinner" *ngIf="succeeded == false && failed == false"></span>
        <span class="spinner-progress" *ngIf="succeeded == false && failed == false" [ngClass]="progress$ ? '' : 'await-text'">{{progress$ ? progress$.toString()+'%' : 'Aguarde'}}</span>
        <mat-icon class="success-icon" *ngIf="succeeded == true">check_circle</mat-icon>
        <mat-icon class="failed-icon" *ngIf="failed == true">cancel</mat-icon>
    </div>
</div>